/*
 * @Author: your name
 * @Date: 2019-11-11 15:34:16
 * @LastEditTime: 2019-11-12 13:00:45
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \source\src\components\onlineMap\mainMap\UCOverlay\DrawGeometryOverlayJs.js
 */

import { UCMapEvent } from "../UCMapJs.js";

export class DrawGeometryOverlayJs {

  constructor() {

    this.id_input_drawItemName = "id_drawItemName";
    this.id_textArea_drawItemRemark = "id_drawItemRemark";
    this.id_a_drawItemDelete = "id_drawItemDelete";
    this.id_a_drawItemSave = "id_drawItemSave";




    this.drawItem = null;


    this.ucOverLay = null;

  }


  init() {

    this.ucOverLay.curDrawItem = this.drawItem;
    this.ucOverLay.init();

  }

  /**
   * 绑定事件
   */
  bindingEvents() {
    //绑定元素事件
    this._bindingDomElementEvents();
  }

  ucRenderFinished(callback) {
    let self = this;
    this.ucOverLay.$nextTick(function () {


      let innerHtml = self.ucOverLay.$el.innerHTML;
      if (callback) {
        callback(innerHtml);
      }
    });



  }

  on_deleteDrawGeometry(callback) {

    if (callback) {
      this.ucOverLay.$on(
        UCMapEvent.DrawGeometryOverlay_deleteGeometry,
        callback
      );
    }
  }

  on_saveDrawGeometry(callback) {
    if (callback) {
      this.ucOverLay.$on(
        UCMapEvent.DrawGeometryOverlay_saveGeometry,
        callback
      );
    }
  }

  _bindingDomElementEvents() {
    let self = this;

    let eleDrawItemDelete = document.getElementById(this.id_a_drawItemDelete);
    eleDrawItemDelete.onclick = function (evt) {
      self._deleteDrawItem();
    };


    let eleDrawItemSave = document.getElementById(this.id_a_drawItemSave);
    eleDrawItemSave.onclick = function (evt) {
      self._saveDrawItem();
    };
    
  }

  _deleteDrawItem() {
    
    this.ucOverLay.$emit(UCMapEvent.DrawGeometryOverlay_deleteGeometry,this.drawItem);
    
  }


  _saveDrawItem() {

    let eleName = document.getElementById(this.id_input_drawItemName);

    if(eleName)
    {
      this.drawItem.name = eleName.value;
    }

    let eleRemark = document.getElementById(this.id_textArea_drawItemRemark);
    if(eleRemark)
    {
      this.drawItem.remark=eleRemark.value;
    }
    
    this.ucOverLay.$emit(UCMapEvent.DrawGeometryOverlay_saveGeometry,this.drawItem);
    
  }






}